import { render, staticRenderFns } from "./TextSection.vue?vue&type=template&id=f8536002&scoped=true"
import script from "./TextSection.vue?vue&type=script&lang=ts"
export * from "./TextSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8536002",
  null
  
)

export default component.exports